module.exports = __webpack_public_path__ + "vue/img/enchildren.ecf4a2fa.jpg";